import { useState, useEffect, useContext } from 'react'
import { useFormik } from "formik"
import axios from 'axios'
import * as Yup from "yup"
import ContextStates from '../../context/ContextStates'
import { Url } from '../Url'

const FEditDomicilio = () => {
    const [domicilio, setDomicilio] = useState('')
    const [observaciones, setObservaciones] = useState('')
    const { domicilioSelected, setViewOpen, modify, setModify, setCliente } = useContext(ContextStates);

    useEffect(() => {
        setDomicilio(domicilioSelected.domicilio)
        setObservaciones(domicilioSelected.observaciones)
    }, [])

    const saveDomicilio = async () => {
        const formData = new FormData()
        if (domicilio !== '') {
            formData.append('id', domicilioSelected.id);
            formData.append('domicilio', domicilio);
            formData.append('observaciones', observaciones);

            try {
                const response = await axios({
                    url: Url + 'api/setDomicilio.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                localStorage.setItem('localClient', JSON.stringify(response.data.results))
                setCliente(response.data.results);
                setViewOpen(false)
            } catch (e) {
                console.log(e)
            }
        }
    }



    return (
        <div className="w-full mx-auto p-5 rounded-2xl">
            <div className="transition-all w-full sm:p-3">
                <h2 className='text-3xl uppercase mb-3 text-center'>Editar Domicilio</h2>
                <div className='flex'>
                    <div className="sm:items-start sm:w-1/2 mx-auto w-full">
                        <label htmlFor="nombre" className="block mt-5 text-gray-600 uppercase font-bold">Domicilio</label>
                        <input
                            className="py-2 px-3 w-full rounded border border-gray-600"
                            id="domicilio"
                            placeholder="Ingrese el nombre"
                            type="text"
                            value={domicilio}
                            onChange={(e) => setDomicilio(e.target.value)}
                        />
                        <label htmlFor="observaciones" className="block text-gray-600 mt-10 uppercase font-bold">Observaciones del Domicilio</label>
                        <input
                            className="py-2 px-3 w-full rounded border border-gray-600"
                            id="observaciones"
                            placeholder="Observaciones de Domicilio"
                            type="text"
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="pb-1">
                <div className="w-full rounded-lg px-3 flex justify-center">
                    <button
                        type="button"
                        className="w-1/4 sm:w-1/6 shadow-md p-3 bg-indigo-600 text-gray-100 hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                        onClick={() => saveDomicilio()}
                    >
                        Guardar
                    </button>
                    <button
                        type="button"
                        className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                        onClick={() => setViewOpen(false)}
                    >
                        Salir
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FEditDomicilio